(() => {
  if (window.LFCHomeCommerceFeedLoaded) return;
  window.LFCHomeCommerceFeedLoaded = true;

  const rootSelector = '[data-home-commerce-feed]';

  const emit = (name, detail) => {
    document.dispatchEvent(new CustomEvent(name, { detail }));
  };

  const getContext = (element) => {
    const module = element.closest('[data-home-module]');
    const card = element.closest('[data-home-product-card]');
    return {
      module: module?.dataset.moduleTitle || '',
      moduleId: module?.dataset.moduleId || '',
      collection: module?.dataset.collection || '',
      position: Number(card?.dataset.productPosition || 0),
      productId: card?.dataset.productId || '',
      variantId: card?.dataset.variantId || ''
    };
  };

  const getCartSurface = () => document.querySelector('cart-drawer') || document.querySelector('cart-notification');

  const updateCartSurface = (cart) => {
    const surface = getCartSurface();
    if (surface && typeof surface.renderContents === 'function') {
      surface.renderContents(cart);
      return;
    }

    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart } }));
    if (window.PUB_SUB_EVENTS && window.publish) {
      try {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'home-commerce-feed', cartData: cart });
      } catch (_) {}
    }
    if (cart.sections?.['cart-icon-bubble']) {
      try {
        const parsed = new DOMParser().parseFromString(cart.sections['cart-icon-bubble'], 'text/html');
        const incoming = parsed.querySelector('#cart-icon-bubble');
        const current = document.querySelector('#cart-icon-bubble');
        if (incoming && current) current.innerHTML = incoming.innerHTML;
      } catch (_) {}
    }

    if (surface && typeof surface.open === 'function') {
      surface.open(document.querySelector('#cart-icon-bubble'));
    } else {
      document.querySelector('#cart-icon-bubble')?.click();
    }
  };

  const setSelectedQuantity = (card, quantity) => {
    const next = Math.max(1, Number(quantity) || 1);
    const output = card.querySelector('[data-home-quantity]');
    const input = card.querySelector('input[name="quantity"]');
    if (output) output.textContent = next;
    if (input) input.value = next;
  };

  const setCardBusy = (card, busy) => {
    card.dataset.busy = busy ? 'true' : 'false';
    card.querySelectorAll('.home-card__add, [data-home-quantity-minus], [data-home-quantity-plus]').forEach((control) => {
      control.disabled = busy;
    });
  };

  const bindFeed = (root) => {
    root.querySelectorAll('[data-home-product-card]').forEach((card) => {
      setSelectedQuantity(card, card.querySelector('[data-home-quantity]')?.textContent || 1);
    });
    if (root.dataset.bound === 'true') return;
    root.dataset.bound = 'true';

    root.addEventListener('click', (event) => {
      const productLink = event.target.closest('[data-home-product-link]');
      if (productLink) {
        emit('lfc:home_product_click', getContext(productLink));
        return;
      }

      const plus = event.target.closest('[data-home-quantity-plus]');
      const minus = event.target.closest('[data-home-quantity-minus]');
      if (!plus && !minus) return;
      const card = event.target.closest('[data-home-product-card]');
      const current = Number(card.querySelector('[data-home-quantity]')?.textContent || 1);
      const next = plus ? current + 1 : Math.max(1, current - 1);
      event.preventDefault();
      setSelectedQuantity(card, next);
    });

    root.addEventListener('submit', async (event) => {
      const form = event.target.closest('[data-home-quick-add]');
      if (!form) return;
      event.preventDefault();
      const card = form.closest('[data-home-product-card]');
      if (!card || card.dataset.busy === 'true') return;
      setCardBusy(card, true);
      const formData = new FormData(form);
      const selectedQuantity = Math.max(1, Number(formData.get('quantity')) || 1);
      const surface = getCartSurface();
      const sections = surface?.getSectionsToRender?.().map((section) => section.id) || ['cart-drawer', 'cart-icon-bubble'];
      formData.append('sections', sections);
      formData.append('sections_url', window.location.pathname);
      let cartData;
      try {
        const response = await fetch(form.action, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData
        });
        if (!response.ok) throw new Error('Não foi possível adicionar o produto.');
        cartData = await response.json();
      } catch (error) {
        console.error(error);
        setCardBusy(card, false);
        form.submit();
        return;
      }

      setSelectedQuantity(card, 1);
      updateCartSurface(cartData);
      setCardBusy(card, false);
      emit('lfc:home_quick_add', { ...getContext(card), quantity: selectedQuantity });
    });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting || entry.target.dataset.viewed === 'true') return;
            entry.target.dataset.viewed = 'true';
            emit('lfc:home_module_view', getContext(entry.target));
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.25 }
      );
      root.querySelectorAll('[data-home-module]').forEach((module) => observer.observe(module));
    }
  };

  const init = (scope = document) => scope.querySelectorAll(rootSelector).forEach(bindFeed);
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('lfc:home_cards_updated', (event) => {
    const root = event.target.closest?.(rootSelector) || event.target.querySelector?.(rootSelector);
    if (root) bindFeed(root);
  });
})();
